import {State, ShippingAPIValues} from '../types'
import {ApiError} from '../../../exceptions'

export enum AddressUpdateAction {
  GET_SHIPPING_ADDRESS = 'addressUpdate/get shipping address',
  GET_SHIPPING_ADDRESS_PENDING = 'addressUpdate/get shipping address is pending',
  GET_SHIPPING_ADDRESS_SUCCESS = 'addressUpdate/get shipping address successful',
  GET_SHIPPING_ADDRESS_FAILURE = 'addressUpdate/get shipping address failed',
  SAVE_SHIPPING_ADDRESS = 'addressUpdate/save shipping address',
  SAVE_SHIPPING_ADDRESS_PENDING = 'addressUpdate/save shipping address is pending',
  SAVE_SHIPPING_ADDRESS_FAILURE = 'addressUpdate/save shipping address failed',
  SAVE_SHIPPING_ADDRESS_SUCCESS = 'addressUpdate/save shipping address is successful',
}

export interface AddressUpdateInitialState {
  shippingAddress: State
}

interface GetShippingAddressPayload {
  orderId: number
}

export interface GetShippingAddress {
  type: AddressUpdateAction.GET_SHIPPING_ADDRESS
  payload: GetShippingAddressPayload
}

export interface GetShippingAddressPending {
  type: AddressUpdateAction.GET_SHIPPING_ADDRESS_PENDING
}

export interface GetShippingAddressSuccess {
  type: AddressUpdateAction.GET_SHIPPING_ADDRESS_SUCCESS
  payload: ShippingAPIValues
}

export interface GetShippingAddressFailure {
  error: boolean
  payload: ApiError | []
  type: AddressUpdateAction.GET_SHIPPING_ADDRESS_FAILURE
}

export interface SaveShippingAddress {
  type: AddressUpdateAction.SAVE_SHIPPING_ADDRESS
}

export interface SaveShippingAddressPending {
  type: AddressUpdateAction.SAVE_SHIPPING_ADDRESS_PENDING
}

export interface SaveShippingAddressSuccess {
  payload: ShippingAPIValues
  type: AddressUpdateAction.SAVE_SHIPPING_ADDRESS_SUCCESS
}

export interface SaveShippingAddressFailure {
  error: boolean
  payload: ApiError | []
  type: AddressUpdateAction.SAVE_SHIPPING_ADDRESS_FAILURE
}

export type ShippingAddressActions =
  | GetShippingAddress
  | GetShippingAddressPending
  | GetShippingAddressSuccess
  | GetShippingAddressFailure
  | SaveShippingAddress
  | SaveShippingAddressPending
  | SaveShippingAddressSuccess
  | SaveShippingAddressFailure
